import useGetAllClientIdentityUsersInfinite from '@/hooks/query/useGetAllClientIdentityUsersInfinite'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import Breadcrumbs from '@/containers/breadcrumbs'

import { Button } from '@/components/button'
import { Card } from '@/components/card'
import Content from '@/components/content'
import LoadMoreButton from '@/components/loadMoreButton'
import PageHeader from '@/components/pageHeader'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/table'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import SettingsNavigation from '../-components/settingsNavigation'

export const Route = createFileRoute('/_authed/$client_code/settings/users/')({
    component: Users,
})

function Users() {
    const { client_code } = Route.useParams()
    const navigate = useNavigate()
    const { data: users, fetchNextPage, hasNextPage, isLoading } = useGetAllClientIdentityUsersInfinite(client_code)
    useSetBreadcrumbs([
        {
            to: '/$client_code/settings',
            text: 'Settings',
            params: { client_code },
        },
        'seperator',
        {
            to: '/$client_code/users',
            text: 'Users',
            params: { client_code },
        },
    ])

    const navigateToInvitations = () => {
        navigate({
            to: '/$client_code/settings/invitations',
            params: { client_code },
        })
    }

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader
                    title="Users"
                    controls={
                        <Button variant={'outline'} className="mb-2" onClick={navigateToInvitations}>
                            View invitations
                        </Button>
                    }
                />
                <SettingsNavigation active="users" />

                <Card hideOverflow>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className="w-64">Name</TableHead>
                                <TableHead>Email</TableHead>
                                <TableHead />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {users?.map(apiKey => (
                                <TableRow key={apiKey.id}>
                                    <TableCell className="w-64">{apiKey.name}</TableCell>
                                    <TableCell>{apiKey.identifier}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <div className="flex justify-center">
                        <LoadMoreButton
                            className="my-4"
                            fetchNextPage={fetchNextPage}
                            isLoading={isLoading}
                            hasNextPage={hasNextPage}
                        />
                    </div>
                </Card>
            </Content>
        </>
    )
}
